export default "__VITE_ASSET__C08ThJf7__"